import {connect} from "react-redux";
import ActivityAccountListing from "./list";
import {bindActionCreators} from "redux";
import {getCreatedActivities} from "../../../../service/Account/action";
import {ratingSave} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    accountActivityList:state.Dropdown.accountActivityList,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getCreatedActivities,
            ratingSave
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivityAccountListing);
